import icon from "../../../assets/images/icon-cugate.svg";

export const LoadingWidget: React.FC<any> = (props) => {
  const { title = `Loading ...` } = props;
  return (
    <div className="loading-widget">
      <div className="logo-img">
        <div>
          <img src={icon} alt="loading" />
        </div>
        <div className="loading-text">{title}</div>
      </div>
    </div>
  );
};